import {
  Routes,
} from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ExternalApiComponent } from './pages/external-api/external-api.component';
import { ErrorComponent } from './pages/error/error.component';
import { authGuardFn } from '@auth0/auth0-angular';
import { BookingComponent } from './components/booking/booking.component';
import { RoomComponent } from './components/room/room.component';
import { BookingListComponent } from './components/booking-list/booking-list.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CheckInComponent } from './components/check-in/check-in.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';

export const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'external-api',
    component: ExternalApiComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'booking',
    component: BookingComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'booking-list',
    component: BookingListComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'room',
    component: RoomComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'check-in',
    component: CheckInComponent,
    canActivate: [authGuardFn],
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuardFn],
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
];
